import { Box, Typography } from '@mui/material'

const ThemeReference = () => {
  return (
    <Box m={10}>
      <Box>
        <Typography color={'primary.main'} variant='h2'>Main colers we are using (Heading 'white')</Typography>
        <Typography color={'secondary.main'} variant='subtitle2' my={1}>Body text ('#68717A)</Typography>
        <Typography color={'secondary.light'} variant='subtitle2'>Body text 2 light ('#ABB5BE)</Typography>
      </Box>
      <Box my={2} bgcolor={'#EFF0F4'} width={'100%'}>
        <Typography color={'primary.main'} fontSize={'10px'} fontWeight={'600'} textAlign={'center'} p={.5}>border or Divider (#EFF0F4)</Typography>
      </Box>

      <Box mb={2} bgcolor={'success.light'} width={'100%'}>
        <Typography color={'#FFF'} variant='h5' textAlign={'center'} p={1.5}>Success as Green (#11895E)</Typography>
      </Box>
      <Box mb={2} bgcolor={'info.main'} width={'100%'}>
        <Typography color={'#FFF'} variant='h5' textAlign={'center'} p={1.5}>Info as Blue (#0071A9)</Typography>
      </Box>
      <Box mb={2} bgcolor={'warning.main'} width={'100%'}>
        <Typography color={'#FFF'} variant='h5' textAlign={'center'} p={1.5}>Warning as Orange (#E99940)</Typography>
      </Box>
      <Box mb={2} bgcolor={'error.main'} width={'100%'}>
        <Typography color={'#FFF'} variant='h5' textAlign={'center'} p={1.5}>Error as Red (#DC3545)</Typography>
      </Box>
    </Box>
  )
}

export default ThemeReference